module.exports = __webpack_public_path__ + "img/panorama_fish_eye.28b4775b.svg";